import { createContext, ReactNode, useContext } from 'react';
import { Backdrop, CircularProgress } from '@mui/material';
import { documentService, IApiDocument } from '@tap/data-providers';
import { UseFetchDataState, useFetchData } from '@tap/mui-ui';
import { TimeTrackingProvider } from '../plugins/TimeTracking/TimeTrackingContext';
import { QCResultProvider } from '../plugins/QCResult/QCResultContext';
/*
*   Провайдер для Documents
*/

export type DocumentContextValue = {
    documentKey: string,
    document?: IApiDocument,
    documentState: UseFetchDataState<IApiDocument>,
    componentProps?: object,
}

export const DocumentContext = createContext<DocumentContextValue | null>(null);

export type DocumentProviderProps = {
    children?: ReactNode,
    documentKey: string,
    reloadIndex?: number,
    componentProps?: object,
}


export const DocumentProvider = ({ documentKey, reloadIndex, componentProps, children }: DocumentProviderProps): JSX.Element => {
    const [documentState, document] = useFetchData(
        () => documentService.getDocumentByKey(documentKey), [documentKey, reloadIndex]);


    return (
        <DocumentContext.Provider
            value={{
                documentKey,
                documentState,
                document,
                componentProps,
            }}
        >
            <QCResultProvider>
                <TimeTrackingProvider>
                    <>
                        {!documentState.isReady && (
                            <Backdrop open={true} invisible={true}>
                                <CircularProgress color='inherit' />
                            </Backdrop>
                        )}
                        {documentState.isReady && children}
                    </>
                </TimeTrackingProvider>
            </QCResultProvider>

        </DocumentContext.Provider>
    );
};

export const useDocument = (): DocumentContextValue => {
    const context = useContext(DocumentContext);

    if (context == null) {
        throw new Error('No DocumentContext provided');
    }

    return context;
};

